import React from 'react';
import { Stack, IconButton, Typography, useTheme } from '@mui/material';
import useLocales from 'hooks/useLocales';
import { IMAGE_URL } from 'utils/axios';
import { Assignment, Download } from '@mui/icons-material';
import { Avatar } from '@mui/material';

export function resolveAttachmentFileName(file: unknown): string | null {
  if (file == null) return null;
  if (typeof file === 'string') {
    const trimmed = file.trim();
    return trimmed || null;
  }
  if (typeof file === 'object') {
    const record = file as Record<string, unknown>;
    const name = record.fileName ?? record.FileName ?? record.name ?? record.url;
    if (typeof name === 'string' && name.trim()) {
      return name.trim();
    }
  }
  return null;
}

export const NewFileViewer = ({ fileName }: { fileName: unknown }) => {
  const { currentLang } = useLocales();
  const theme = useTheme();

  const resolvedName = resolveAttachmentFileName(fileName);
  if (!resolvedName) {
    return null;
  }

  const dotIndex = resolvedName.lastIndexOf('.');
  const fileFirstName = dotIndex > 0 ? resolvedName.slice(0, dotIndex) : resolvedName;
  const fileSecondName = dotIndex > 0 ? resolvedName.slice(dotIndex + 1) : '';
  const displayLabel = fileSecondName
    ? `${fileFirstName.slice(0, 5)}.${fileSecondName}`
    : fileFirstName.slice(0, 12);

  return (
    <Stack
      sx={{
        bgcolor: theme.palette.background.default,
        width: '100%',
        borderRadius: '5px',
        overflow: 'hidden'
      }}
      flexDirection="row-reverse"
      alignItems="center"
      gap={1}
    >
      <Stack width="80%" direction="row-reverse" alignItems="center" gap={1} flexWrap="wrap">
        <Avatar sx={{ bgcolor: theme.palette.primary.main }} variant="square">
          <Assignment sx={{ color: 'white', my: 1 }} />
        </Avatar>
        <Typography variant="body2">{displayLabel}</Typography>
      </Stack>

      <IconButton
        onClick={() => {
          window.open(IMAGE_URL + resolvedName, '_blank', 'noopener,noreferrer');
        }}
        sx={{
          width: '20%',
          display: 'flex',
          justifyContent: currentLang?.value === 'ar' ? 'flex-start' : 'flex-end'
        }}
      >
        <Download sx={{ color: theme.palette.grey[500], cursor: 'pointer' }} />
      </IconButton>
    </Stack>
  );
};
